import { Suspense, lazy } from 'react';

// react-markdown (+ remark/micromark) is ~100KB and only used after the
// landing page — for the report, on-screen brief and policy modals. Load it
// as a separate chunk so it stays out of the initial bundle.
const ReactMarkdown = lazy(() => import('react-markdown'));

export default function Markdown({ children, components }) {
  return (
    <Suspense fallback={null}>
      <ReactMarkdown components={components}>{children}</ReactMarkdown>
    </Suspense>
  );
}
